module.exports = __webpack_public_path__ + "img/gracias.737b9bf8.png";